'use client'
export default function getToken() {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem('access_token');
  } else {
    // Handle the case where localStorage is not available (e.g., server-side rendering)
    return null; // or handle it according to your application logic
  }
}
